import React, { useState, useEffect } from 'react';
import { Server, Wifi } from 'lucide-react';

const TOTAL_SECONDS = 90;

const ColdStart = () => {
  const [progress, setProgress] = useState(0);   // 0–100
  const [elapsed, setElapsed] = useState(0);     // segundos decorridos
  const [dots, setDots] = useState('.');         // animação de "..."

  // Barra de progresso — avança de 0 a 99% ao longo de 90s.
  // Fica em 99% até o servidor responder de verdade (componente é desmontado).
  useEffect(() => {
    let ticks = 0;
    const STEP_MS = 500; // atualiza a cada 500ms para animação suave

    const timer = setInterval(() => {
      ticks += 1;
      const elapsedSec = Math.floor((ticks * STEP_MS) / 1000);
      const pct = Math.min((ticks * STEP_MS) / (TOTAL_SECONDS * 1000) * 100, 99);
      setProgress(pct);
      setElapsed(elapsedSec);

      if (elapsedSec >= TOTAL_SECONDS) clearInterval(timer);
    }, STEP_MS);

    return () => clearInterval(timer);
  }, []);

  // Animação dos pontos: "." → ".." → "..." → "." → …
  useEffect(() => {
    const dotTimer = setInterval(() => {
      setDots(prev => (prev.length >= 3 ? '.' : prev + '.'));
    }, 500);
    return () => clearInterval(dotTimer);
  }, []);

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center"
      style={{ background: 'rgba(15, 23, 42, 0.82)' }}
    >
      {/* Blur suave no conteúdo atrás */}
      <div className="absolute inset-0 backdrop-blur-sm" />

      {/* Card central */}
      <div className="relative z-10 bg-white rounded-2xl shadow-2xl w-full max-w-sm mx-4 overflow-hidden">

        {/* Faixa de cabeçalho */}
        <div className="bg-[#0A3D73] px-6 py-5 flex flex-col items-center gap-2">
          {/* Ícone animado */}
          <div className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center mb-1">
            <Server size={22} className="text-white animate-pulse" />
          </div>

          {/* Logo */}
          <h1 className="text-2xl font-black tracking-tight text-white">
            Rep<span className="text-blue-300">Flow</span>
          </h1>
          <p className="text-blue-200 text-[10px] font-bold uppercase tracking-[0.2em]">
            Gestão de Representação Comercial
          </p>
        </div>

        {/* Corpo */}
        <div className="px-6 py-6 flex flex-col gap-5">

          {/* Mensagem principal */}
          <div className="text-center">
            <p className="text-sm font-black text-slate-800">
              Iniciando o servidor{dots}
            </p>
            <p className="text-xs text-slate-500 font-semibold mt-1.5 leading-relaxed">
              Isso pode levar até 1 minuto.
            </p>
          </div>

          {/* Barra de progresso */}
          <div>
            <div className="w-full bg-slate-100 rounded-full h-2.5 overflow-hidden">
              <div
                className="h-full bg-[#0A3D73] rounded-full"
                style={{
                  width: `${progress}%`,
                  transition: 'width 0.45s ease-out',
                }}
              />
            </div>
            <div className="flex justify-between mt-1.5">
              <span className="text-[10px] font-bold text-slate-400">
                {elapsed}s
              </span>
              <span className="text-[10px] font-bold text-slate-400">
                {TOTAL_SECONDS}s
              </span>
            </div>
          </div>

          {/* Separador */}
          <div className="border-t border-slate-100" />

          {/* Mensagem secundária */}
          <div className="flex items-start gap-2.5">
            <Wifi size={13} className="text-slate-300 flex-shrink-0 mt-0.5" />
            <p className="text-[11px] text-slate-400 font-semibold leading-relaxed">
              Isso acontece após períodos de inatividade. O servidor será mantido
              ativo assim que você entrar no sistema.
            </p>
          </div>

        </div>

        {/* Barra de carregamento indeterminada no rodapé */}
        <div className="h-1 bg-slate-100 overflow-hidden">
          <div
            className="h-full bg-blue-200"
            style={{
              animation: 'coldstart-slide 1.8s ease-in-out infinite',
            }}
          />
        </div>
      </div>

      {/* Keyframe injetado inline — não precisa de arquivo CSS extra */}
      <style>{`
        @keyframes coldstart-slide {
          0%   { width: 0%;   margin-left: 0%; }
          50%  { width: 60%;  margin-left: 20%; }
          100% { width: 0%;   margin-left: 100%; }
        }
      `}</style>
    </div>
  );
};

export default ColdStart;
